import React from "react";
import { useLanguage } from "../../../../contexts";
import { P, useEnergia } from "../engine";
import { ConInstalacion, Notice, Section, StatusBadge } from "../common/SectionCommon";
import { GraficoCatalogo } from "../common/Grafico";
import "../common/common.scss";
import "./IndexAndVerdict.scss";

const fmt = (v, d = 0) => P.fmt(v, d);
// semáforo único (hoja 01, fila 6), comparado con el valor mostrado (entero)
const semaforo = (v) => { const r = Math.round(v); return r >= P.SEM_V ? "ok" : r >= P.SEM_A ? "warn" : "danger"; };
const CLASE_DICTAMEN = { "badge-good": "Cumple", "badge-warn": "Brecha parcial", "badge-bad": "Brecha mayor" };

// Índice de desempeño energético y estado de la medición (hoja 01, bloque 5; filas 32–34, 41, 94, 114, 115).
export function IndexAndVerdict({ installation }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const vista = useEnergia(installation);

  return (
    <ConInstalacion installation={installation} vista={vista} t={t}>
      {(f) => {
        const sc = P.computeScore(f);
        const d = P.dictamen(f);
        const dims = [
          ["energy_performance_dim_efficiency", "energy_performance_dim_efficiency_q", "energy_performance_dim_efficiency_f", sc.eficiencia],
          ["energy_performance_dim_trend", "energy_performance_dim_trend_q", "energy_performance_dim_trend_f", sc.tendencia],
          ["energy_performance_dim_data", "energy_performance_dim_data_q", "energy_performance_dim_data_f", sc.dato],
          ["energy_performance_dim_management", "energy_performance_dim_management_q", "energy_performance_dim_management_f", sc.gestion],
        ];
        return (
          <div className="ep-screen">
            <h3 className="ep-screen__title">{t("energy_performance_index_title")}</h3>
            <p className="ep-screen__intro">{t("energy_performance_index_intro")}</p>

            <div className="ep-index">
              <div className={`ep-index__big ep-index__big--${sc.suficiente ? semaforo(sc.total) : "neutral"}`}>{P.scoreFmt(sc)}</div>
              <div>
                <div className="ep-index__label">{P.scoreLbl(sc)}</div>
                <p className="ep-section__note">{t("energy_performance_index_weights")}</p>
                {sc.suficiente && <p className="ep-section__note">{t("energy_performance_index_base").replace("{n}", fmt(sc.cobRef, 0))}{f._ejemplo ? ` ${t("energy_performance_index_example_targets")}` : ""}</p>}
              </div>
            </div>
            {!sc.suficiente && (
              <Notice titulo={t("energy_performance_index_pending")}>
                <ul>{(sc.faltan || []).map((x, i) => <li key={i}>{x}</li>)}</ul>
              </Notice>
            )}

      <div className="ep-charts"><GraficoCatalogo f={f} id="indice_dim" t={t} /></div>
            <Section title={t("energy_performance_index_dims")}>
              <div className="ep-table">
                <table>
                  <thead><tr><th>{t("energy_performance_index_dimension")}</th><th>{t("energy_performance_index_what")}</th><th>{t("energy_performance_iden_formula")}</th><th>{t("energy_performance_iden_value")}</th></tr></thead>
                  <tbody>
                    {dims.map(([n, q, fo, v]) => (
                      <tr key={n}>
                        <td><strong>{t(n)}</strong></td>
                        <td className="ep-section__note">{t(q)}</td>
                        <td className="ep-section__note">{t(fo)}</td>
                        <td className={`ep-mono ep-index__dim--${v == null ? "neutral" : semaforo(v)}`}>{v == null ? t("energy_performance_not_evaluable") : fmt(v, 0)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Section>

            <Section title={t("energy_performance_measurement_status")} note={t("energy_performance_measurement_status_note")}>
              <p><StatusBadge estado={CLASE_DICTAMEN[d.cls] || "Pendiente"}>{d.nivel}</StatusBadge></p>
              <p className="ep-audit__reading">{d.lectura}</p>
            </Section>
          </div>
        );
      }}
    </ConInstalacion>
  );
}
